module.exports = {"510121001":"赵镇街道","510121002":"官仓街道","510121003":"栖贤街道","510121004":"高板街道","510121005":"白果街道","510121006":"淮口街道","510121106":"五凤镇","510121109":"三溪镇","510121110":"福兴镇","510121111":"金龙镇","510121112":"赵家镇","510121113":"竹篙镇","510121116":"转龙镇","510121117":"土桥镇","510121118":"云合镇","510121119":"又新镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510121.json
// module id = 2394
// module chunks = 0